import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const RevealLines = ({ lines, className = "", delay = 0, once = true }) => (
  <motion.span
    className={`reveal-lines block ${className}`}
    initial="hidden"
    whileInView="visible"
    viewport={{ once, margin: "-8% 0px" }}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className="block"
          variants={{ hidden: { y: "115%" }, visible: { y: 0 } }}
          transition={{ duration: 0.9, delay: delay + i * 0.12, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 32, ...rest }) => (
  <motion.div
    className={`min-w-0 ${className}`}
    {...rest}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", light = false }) => (
  <FadeUp className={className}>
    <span
      className={`inline-flex items-center gap-3 text-xs font-medium uppercase tracking-[0.25em] ${light ? "text-white/60" : "text-black/50"}`}
    >
      <span className={`h-px w-8 shrink-0 ${light ? "bg-white/40" : "bg-black/30"}`} />
      {children}
    </span>
  </FadeUp>
);
